module.exports = __webpack_public_path__ + "img/ico_check_black.bfd03674.png";